const NATIONALITY_COUNTRY = {
  Afghan: "Afghanistan",
  Albanian: "Albania",
  Algerian: "Algeria",
  "American Samoan": "American Samoa",
  Andorran: "Andorra",
  Angolan: "Angola",
  Argentinian: "Argentina",
  Armenian: "Armenia",
  Australian: "Australia",
  Austrian: "Austria",
  Azerbaijani: "Azerbaijan",
  Bahamian: "Bahamas",
  Bahraini: "Bahrain",
  Bangladeshi: "Bangladesh",
  Barbadian: "Barbados",
  Belarusian: "Belarus",
  Belgian: "Belgium",
  Belizean: "Belize",
  Beninese: "Benin",
  Bhutanese: "Bhutan",
  Bolivian: "Bolivia",
  Bosnian: "Bosnia-Herzegovina",
  Botswanan: "Botswana",
  Brazilian: "Brazil",
  British: "United Kingdom",
  Bruneian: "Brunei",
  Bulgarian: "Bulgaria",
  Burkinabe: "Burkina Faso",
  Burundian: "Burundi",
  Cambodian: "Cambodia",
  Cameroonian: "Cameroon",
  Canadian: "Canada",
  "Cape Verdean": "Cape Verde",
  "Central African": "Central African Republic",
  Chadian: "Chad",
  Chilean: "Chile",
  Chinese: "China",
  Colombian: "Colombia",
  Comoran: "Comoros",
  Congolese: "Republic of the Congo",
  "Costa Rican": "Costa Rica",
  Croatian: "Croatia",
  Cuban: "Cuba",
  Cypriot: "Cyprus",
  Czech: "Czech Republic",
  Danish: "Denmark",
  Djiboutian: "Djibouti",
  Dominican: "Dominican Republic",
  Dutch: "Netherlands",
  "East Timorese": "East Timor",
  Ecuadorian: "Ecuador",
  Egyptian: "Egypt",
  Emirati: "United Arab Emirates",
  "Equatorial Guinean": "Equatorial Guinea",
  Eritrean: "Eritrea",
  Estonian: "Estonia",
  Ethiopian: "Ethiopia",
  Fijian: "Fiji",
  Filipino: "Philippines",
  Finnish: "Finland",
  French: "France",
  Gabonese: "Gabon",
  Gambian: "Gambia",
  Georgian: "Georgia",
  German: "Germany",
  Ghanaian: "Ghana",
  Greek: "Greece",
  Grenadian: "Grenada",
  Guatemalan: "Guatemala",
  Guinean: "Guinea",
  Guyanese: "Guyana",
  Haitian: "Haiti",
  Honduran: "Honduras",
  Hungarian: "Hungary",
  Icelandic: "Iceland",
  Indian: "India",
  Indonesian: "Indonesia",
  Iranian: "Iran",
  Iraqi: "Iraq",
  Irish: "Ireland",
  Israeli: "Israel",
  Italian: "Italy",
  Ivorian: "Cote d’Ivoire",
  Jamaican: "Jamaica",
  Japanese: "Japan",
  Jordanian: "Jordan",
  Kazakhstani: "Kazakhstan",
  Kenyan: "Kenya",
  Kiribati: "Kiribati",
  Kuwaiti: "Kuwait",
  Kyrgyz: "Kyrgyzstan",
  Laotian: "Laos",
  Latvian: "Latvia",
  Lebanese: "Lebanon",
  Lesotho: "Lesotho",
  Liberian: "Liberia",
  Libyan: "Libya",
  Liechtensteiner: "Liechtenstein",
  Lithuanian: "Lithuania",
  Luxembourgish: "Luxembourg",
  Macedonian: "North Macedonia",
  Malagasy: "Madagascar",
  Malawian: "Malawi",
  Malaysian: "Malaysia",
  Maldivian: "Maldives",
  Malian: "Mali",
  Maltese: "Malta",
  Marshallese: "Marshall Islands",
  Mauritanian: "Mauritania",
  Mauritian: "Mauritius",
  Mexican: "Mexico",
  Micronesian: "Micronesia",
  Moldovan: "Moldova",
  Monacan: "Monaco",
  Mongolian: "Mongolia",
  Montenegrin: "Montenegro",
  Moroccan: "Morocco",
  Mozambican: "Mozambique",
  Myanmar: "Myanmar",
  Namibian: "Namibia",
  Nauruan: "Nauru",
  Nepalese: "Nepal",
  "New Zealander": "New Zealand",
  Nicaraguan: "Nicaragua",
  Nigerian: "Nigeria",
  Nigerien: "Niger",
  "North Korean": "North Korea",
  Norwegian: "Norway",
  Omani: "Oman",
  Pakistani: "Pakistan",
  Palauan: "Palau",
  Palestinian: "Palestine",
  Panamanian: "Panama",
  "Papua New Guinean": "Papua New Guinea",
  Paraguayan: "Paraguay",
  Peruvian: "Peru",
  Polish: "Poland",
  Portuguese: "Portugal",
  Qatari: "Qatar",
  Romanian: "Romania",
  Russian: "Russia",
  Rwandan: "Rwanda",
  "Saint Lucian": "Saint Lucia",
  Salvadoran: "El Salvador",
  Samoan: "Samoa",
  "San Marinese": "San Marino",
  "Sao Tomean": "Sao Tome & Principe",
  Saudi: "Saudi Arabia",
  Senegalese: "Senegal",
  Serbian: "Serbia",
  Seychellois: "Seychelles",
  "Sierra Leonean": "Sierra Leone",
  Singaporean: "Singapore",
  Slovak: "Slovakia",
  Slovenian: "Slovenia",
  "Solomon Islander": "Solomon Islands",
  Somali: "Somalia",
  "South African": "South Africa",
  "South Korean": "South Korea",
  "South Sudanese": "South Sudan",
  Spanish: "Spain",
  "Sri Lankan": "Sri Lanka",
  Sudanese: "Sudan (including Darfur)",
  Surinamese: "Suriname",
  Swazi: "Eswatini (formerly named as Swaziland)",
  Swedish: "Sweden",
  Swiss: "Switzerland",
  Syrian: "Syria",
  Taiwanese: "Taiwan",
  Tajik: "Tajikistan",
  Tanzanian: "Tanzania",
  Thai: "Thailand",
  Togolese: "Togo",
  Tongan: "Tonga",
  Trinidadian: "Trinidad & Tobago",
  Tunisian: "Tunisia",
  Turkish: "Turkey",
  Turkmen: "Turkmenistan",
  Tuvaluan: "Tuvalu",
  Ugandan: "Uganda",
  Ukrainian: "Ukraine",
  Uruguayan: "Uruguay",
  US: "United States",
  Uzbekistani: "Uzbekistan",
  Vanuatuan: "Vanuatu",
  Vatican: "Vatican City",
  Venezuelan: "Venezuela",
  Vietnamese: "Vietnam",
  Yemeni: "Yemen",
  Zambian: "Zambia",
  Zimbabwean: "Zimbabwe",
  Other: "",
};

const COUNTRY_ALIASES = {
  "antigua and barbuda": "Antigua & Barbuda",
  "bosnia and herzegovina": "Bosnia-Herzegovina",
  congo: "Republic of the Congo",
  "dr congo": "Democratic Republic of the Congo",
  "cote d'ivoire": "Cote d’Ivoire",
  "cote d’ivoire": "Cote d’Ivoire",
  "ivory coast": "Cote d’Ivoire",
  eswatini: "Eswatini (formerly named as Swaziland)",
  swaziland: "Eswatini (formerly named as Swaziland)",
  sudan: "Sudan (including Darfur)",
  "sao tome and principe": "Sao Tome & Principe",
  "trinidad and tobago": "Trinidad & Tobago",
  "timor-leste": "East Timor",
  vatican: "Vatican City",
  czech: "Czech Republic",
  macedonia: "North Macedonia",
};

export const canonicalCountryName = (value) => {
  const name = String(value ?? "").trim();
  if (!name) return "";
  return COUNTRY_ALIASES[name.toLowerCase()] || name;
};

export const nationalityCountry = (value) => {
  const name = String(value ?? "").trim();
  if (!name || name.toLowerCase() === "other") return "";
  if (Object.prototype.hasOwnProperty.call(NATIONALITY_COUNTRY, name)) {
    return NATIONALITY_COUNTRY[name];
  }
  return canonicalCountryName(name);
};
